var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 48,
    viewBox: "0 0 168 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 8,
    height: 16,
    rx: 4,
    fill: "#7367F0",
    fillOpacity: 0.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#7367F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 8,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.48
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 8,
    height: 16,
    rx: 4,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 8,
    width: 8,
    height: 32,
    rx: 4,
    fill: "#7367F0",
    fillOpacity: 0.48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 12,
    width: 8,
    height: 24,
    rx: 4,
    fill: "#7367F0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 4,
    width: 8,
    height: 40,
    rx: 4,
    fill: "white",
    fillOpacity: 0.48
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 8,
    width: 8,
    height: 32,
    rx: 4,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 8,
    height: 48,
    rx: 4,
    fill: "#7367F0",
    fillOpacity: 0.48
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 4,
    width: 8,
    height: 40,
    rx: 4,
    fill: "#7367F0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 4,
    width: 8,
    height: 40,
    rx: 4,
    fill: "white",
    fillOpacity: 0.48
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 8,
    width: 8,
    height: 32,
    rx: 4,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 8,
    width: 8,
    height: 32,
    rx: 4,
    fill: "#7367F0",
    fillOpacity: 0.48
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 12,
    width: 8,
    height: 24,
    rx: 4,
    fill: "#7367F0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 12,
    width: 8,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.48
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 16,
    width: 8,
    height: 16,
    rx: 4,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 16,
    width: 8,
    height: 16,
    rx: 4,
    fill: "#7367F0",
    fillOpacity: 0.48
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 20,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#7367F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgVideo);
export default __webpack_public_path__ + "static/media/BgVideo.e818b0677d8587853b6d277e25c7887b.svg";
export { ForwardRef as ReactComponent };